import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useEffect } from 'react';

const IGNORE_SELECTORS = [
  'li',
  'button',
  'input',
  '[data-ignore-outside-click]',
  '[class*="ignore-outside-click"]',
];

const OVERLAYS_IGNORE_INTERACTIVE_CLICKS = [
  'chat-overlay',
  'bot-error-overlay',
];

const isChatOrBotErrorOverlay = (
  overlayElement: HTMLElement | null | undefined,
): boolean =>
  overlayElement != null &&
  OVERLAYS_IGNORE_INTERACTIVE_CLICKS.some(className =>
    overlayElement.classList.contains(className),
  );

const isIgnoredClickTarget = (target: HTMLElement): boolean =>
  IGNORE_SELECTORS.some(selector => target.closest(selector));

export const useOverlayClickOutside = (
  overlayRef: React.RefObject<OverlayPanel>,
  triggerRef?: React.RefObject<HTMLElement | null>,
): void => {
  useEffect(() => {
    const handleClick = (event: MouseEvent): void => {
      if (!overlayRef.current?.isVisible()) {
        return;
      }

      const target = event.target as HTMLElement;
      const overlayElement = overlayRef.current?.getElement();

      if (
        overlayElement?.contains(target) ||
        triggerRef?.current?.contains(target) ||
        (isChatOrBotErrorOverlay(overlayElement) &&
          isIgnoredClickTarget(target))
      ) {
        return;
      }
      overlayRef.current?.hide();
    };

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [overlayRef, triggerRef]);
};
